export default function DelegatedPage() {

  // useEffect(() => {
  //   window.location.href = process.env.REACT_APP_AUTH0_DELEGATED_PAGE;
  // }, []);


  // TODO: Temporary
  return (
    <div>
      <p>Delegated page</p>

      <a href={process.env.REACT_APP_AUTH0_DELEGATED_PAGE}>Go to page</a>
    </div>
  );
}
